import _sfc_main from "./component-library281.mjs";
import "./component-library282.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.isDialogOpen ? _c("dialog", { ref: "dialogElement", class: ["base-dialog", _vm.customClass], attrs: { "aria-label": _vm.ariaLabel, "aria-modal": "true" }, on: { "click": function($event) {
    if ($event.target !== $event.currentTarget)
      return null;
    return _setup.handleBackdropClick.apply(null, arguments);
  }, "close": _setup.closeNative } }, [_c("div", { ref: "dialogContainer", staticClass: "base-dialog__container", class: _vm.customContainerClass }, [_c("div", { staticClass: "base-dialog__header" }, [_vm._t("header", function() {
    return [_vm.headingText ? _c(_setup.Heading, { attrs: { "tag": "h3", "size": "md" }, domProps: { "innerHTML": _vm._s(_vm.headingText) } }) : _vm._e()];
  }, { "close": _setup.closeDialog })], 2), _c(_setup.LinkButton, { staticClass: "base-dialog__close", attrs: { "autofocus": _vm.closeAutofocus, "tag": "button", "type": "button", "transparent": "", "aria-label": "Fenster schließen" }, on: { "click": _setup.closeDialog } }, [_c("span", { staticClass: "base-dialog__close-icon" })]), _c("div", { staticClass: "base-dialog__body" }, [_vm._t("default", null, { "close": _setup.closeDialog })], 2), _c("div", { staticClass: "base-dialog__footer" }, [_vm._t("footer", null, { "close": _setup.closeDialog })], 2)], 1)]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c7cce3c0",
  null,
  null
);
const BaseDialog = __component__.exports;
export {
  BaseDialog as default
};
